'use strict';

/**
 * Module definition file
 *
 * All services, controllers, and directives are registered with angular here
 *
 * Bower dependencies should NOT be require here. They should be required in tests/lib.js.
 */

require('./controls');
require('./layer');

var map = angular.module('saturn.map', [
  'gettext',
  'leaflet-directive',
  'saturn.flux',
  'saturn.map.controls',
  'saturn.map.layer',
]);

var MapActions = require('./MapActions');
var MapConfigProvider = require('./MapConfigProvider');
var MapDirective = require('./MapDirective');
var MapRegistry = require('./MapRegistry');
var MapStore = require('./MapStore');
var MapStrings = require('./MapStrings');
var MapUtils = require('./MapUtils');
var MapWrapper = require('./MapWrapper');

map.run(['$injector', 'sbMapStrings', function ($injector, MapStrings) {
  // Customize Leaflet behavior
  var MapSetup = require('./MapSetup');
  $injector.invoke(MapSetup);
  MapStrings.init();
}]);

map.constant('SB_MAP_DISPATCHER_ID', 'SBMap');

// ## Services, Factories, and Providers
map.provider('sbMapConfig', MapConfigProvider);

map.factory('sbMapActions', MapActions);
map.factory('sbMapStore', MapStore);
map.factory('sbMapWrapper', MapWrapper);

map.service('sbMapStrings', MapStrings);
map.service('sbMapRegistry', MapRegistry);
map.service('sbMapUtils', MapUtils);

// ## Directives
map.directive('sbMap', MapDirective);


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/index.js